module.exports = __webpack_public_path__ + "static/media/UNI-301-badge.ca65a514.svg";